import { Action, createAction, props } from '@ngrx/store';

export const openInfoBanner = createAction(
  '[InfoBanner] Open Info Banner',
  props<{
    showBanner: boolean;
    message: string;
    closeButtonText?: string;
    closeButtonAction?: Action;
    primaryButtonText?: string;
    primaryButtonAction?: Action;
    showBannerWithError?: boolean;
  }>()
);

export const closeInfoBanner = createAction('[InfoBanner] Close Info Banner');

export const runPrimaryAction = createAction('[InfoBanner] Run Primary Action');

export const testAction = createAction('[InfoBanner] Test Action');

// Example Usage for Information Banner
// this.store.dispatch(openInfoBanner({
//   showBanner: true,
//   message: 'Test',
//   primaryButtonText: 'Close me',
//   primaryButtonAction: testAction()
// }))
